<template>
  <div class="supersession-line">
    <template v-if="supersessionToEdit">
      <!-- Desktop Layout -->
      <div class="desktop-layout hidden md:flex">
        <div class="inputs-container">
          <input
            type="text"
            class="form-input"
            placeholder="Supersession"
            v-model="supersessionToEdit.ALTERNATIVE"
            :disabled="!editing || loading"
          />
          <input
            type="text"
            class="form-input"
            placeholder="Extra info"
            v-model="supersessionToEdit.info"
            :disabled="!editing || loading"
          />
        </div>
        <div class="actions-container">
          <template v-if="!editing">
            <button
              @click="editSupersession()"
              class="action-btn edit-btn"
              title="Edit"
            >
              <i class="mdi mdi-pencil"></i>
            </button>
            <button
              @click="deleteSupersession()"
              class="action-btn delete-btn"
              title="Delete"
            >
              <i class="mdi mdi-delete"></i>
            </button>
          </template>
          <template v-else>
            <button
              @click="saveUpdate()"
              class="action-btn save-btn"
              title="Save"
            >
              <i class="mdi mdi-check"></i>
            </button>
            <button
              @click="discardUpdate()"
              class="action-btn cancel-btn"
              title="Cancel"
            >
              <i class="mdi mdi-close"></i>
            </button>
          </template>
        </div>
      </div>

      <!-- Mobile Layout -->
      <div class="mobile-layout md:hidden">
        <div class="mobile-card">
          <div class="input-section">
            <label class="input-label">Supersession</label>
            <input
              type="text"
              class="form-input"
              placeholder="Supersession"
              v-model="supersessionToEdit.ALTERNATIVE"
              :disabled="!editing || loading"
            />
          </div>
          <div class="input-section">
            <label class="input-label">Extra Info</label>
            <input
              type="text"
              class="form-input"
              placeholder="Extra info"
              v-model="supersessionToEdit.info"
              :disabled="!editing || loading"
            />
          </div>
          <div class="mobile-actions">
            <template v-if="!editing">
              <button @click="editSupersession()" class="mobile-btn edit-btn">
                <i class="mdi mdi-pencil"></i>
                <span>Edit</span>
              </button>
              <button
                @click="deleteSupersession()"
                class="mobile-btn delete-btn"
              >
                <i class="mdi mdi-delete"></i>
                <span>Delete</span>
              </button>
            </template>
            <template v-else>
              <button @click="saveUpdate()" class="mobile-btn save-btn">
                <i class="mdi mdi-check"></i>
                <span>Save</span>
              </button>
              <button @click="discardUpdate()" class="mobile-btn cancel-btn">
                <i class="mdi mdi-close"></i>
                <span>Cancel</span>
              </button>
            </template>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import { requestDeleteSupersession } from "@/api/store/SupersessionsService.js";
import { requestUpdateSupersession } from "@/api/masterAdmin/SupersessionsService.js";
export default {
  props: {
    supersession: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editing: false,
      loading: false,
      supersessionToEdit: null
    };
  },
  mounted() {
    this.supersessionToEdit = { ...this.supersession };
  },
  methods: {
    deleteSupersession() {
      if (
        confirm(
          "Please confirm you wan to delete the supersession " +
            this.supersessionToEdit.ALTERNATIVE
        )
      ) {
        requestDeleteSupersession(this.supersessionToEdit.ID).then(() => {
          this.$toast.open({
            message: "Supersession deleted",
            type: "success",
            position: "top-right"
          });
          this.$emit("deletedSupersession", this.supersessionToEdit.ID);
        });
      }
    },
    editSupersession() {
      this.editing = true;
    },
    saveUpdate() {
      requestUpdateSupersession(
        this.supersessionToEdit.ID,
        this.supersessionToEdit.info
      ).then(() => {
        this.$toast.open({
          message: "Supersession updated",
          type: "success",
          position: "top-right"
        });
        this.editing = false;
      });
    },
    discardUpdate() {
      this.supersessionToEdit = { ...this.supersession };
      this.editing = false;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/style/css/generic-variables.scss";

.supersession-line {
  margin-top: 12px;

  // Desktop Layout
  .desktop-layout {
    display: flex;
    gap: 12px;
    align-items: stretch;
    padding: 12px;
    background: white;
    border: 1px solid #e5e7eb;
    border-radius: 6px;
    transition: box-shadow 0.2s;

    &:hover {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    }

    .inputs-container {
      flex: 1;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;

      .form-input {
        width: 100%;
        padding: 8px 12px;
        border: 1px solid #d1d5db;
        border-radius: 4px;
        font-size: 14px;
        transition: border-color 0.2s, box-shadow 0.2s;

        &:focus {
          outline: none;
          border-color: $link-color-1;
          box-shadow: 0 0 0 3px rgba(18, 110, 106, 0.1);
        }

        &:disabled {
          background-color: #f9fafb;
          cursor: not-allowed;
        }

        &::placeholder {
          color: #9ca3af;
        }
      }
    }

    .actions-container {
      display: flex;
      gap: 8px;
      align-items: center;

      .action-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 36px;
        height: 36px;
        border: none;
        border-radius: 4px;
        cursor: pointer;
        transition: background-color 0.2s, transform 0.1s;

        i {
          font-size: 18px;
        }

        &:active {
          transform: scale(0.95);
        }

        &.edit-btn {
          background-color: #3b82f6;
          color: white;

          &:hover {
            background-color: #2563eb;
          }
        }

        &.delete-btn {
          background-color: #ef4444;
          color: white;

          &:hover {
            background-color: #dc2626;
          }
        }

        &.save-btn {
          background-color: #10b981;
          color: white;

          &:hover {
            background-color: #059669;
          }
        }

        &.cancel-btn {
          background-color: #6b7280;
          color: white;

          &:hover {
            background-color: #4b5563;
          }
        }
      }
    }
  }

  // Mobile Layout
  .mobile-layout {
    .mobile-card {
      padding: 15px;
      background: white;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

      .input-section {
        margin-bottom: 12px;

        &:last-of-type {
          margin-bottom: 15px;
        }

        .input-label {
          display: block;
          font-size: 12px;
          font-weight: 500;
          color: #6b7280;
          text-transform: uppercase;
          margin-bottom: 6px;
          letter-spacing: 0.5px;
        }

        .form-input {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #d1d5db;
          border-radius: 6px;
          font-size: 16px;
          transition: border-color 0.2s, box-shadow 0.2s;

          &:focus {
            outline: none;
            border-color: $link-color-1;
            box-shadow: 0 0 0 3px rgba(18, 110, 106, 0.1);
          }

          &:disabled {
            background-color: #f9fafb;
            cursor: not-allowed;
            opacity: 0.7;
          }

          &::placeholder {
            color: #9ca3af;
          }
        }
      }

      .mobile-actions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 10px;
        padding-top: 15px;
        border-top: 1px solid #e5e7eb;

        .mobile-btn {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 10px 16px;
          border: none;
          border-radius: 6px;
          font-size: 15px;
          font-weight: 500;
          cursor: pointer;
          transition: background-color 0.2s, transform 0.1s;
          min-height: 44px;

          i {
            font-size: 18px;
          }

          &:active {
            transform: scale(0.98);
          }

          &.edit-btn {
            background-color: #3b82f6;
            color: white;

            &:hover {
              background-color: #2563eb;
            }
          }

          &.delete-btn {
            background-color: #ef4444;
            color: white;

            &:hover {
              background-color: #dc2626;
            }
          }

          &.save-btn {
            background-color: #10b981;
            color: white;

            &:hover {
              background-color: #059669;
            }
          }

          &.cancel-btn {
            background-color: #6b7280;
            color: white;

            &:hover {
              background-color: #4b5563;
            }
          }
        }
      }
    }
  }
}
</style>
